import { useEffect } from "react";
import { CommerceApiApi } from "../../../apis/CommerceApiApi";
import { useApiInfoContextValueHook } from "../../../contexts/ApiInfoContext";
import { SellertoolSignatureUtils } from "../../../utils/sellertool-signature-utils";
import { useCommerceApiStoreInfoActionsContextHook, useCommerceApiStoreInfoValueContextHook } from "./contexts/CommerceApiStoreInfoContext";
import { WegetCommerceApiStoreList } from "./wegets/weget-commerce-api-store-list/weget-commerce-api-store-list";
import styled from 'styled-components';
import { WegetCollectionButton } from "./wegets/weget-collection-button/weget-collection-button";
import { useQueryParamsHook } from "../../../utils/useQueryParamsHook";
import { WegetViewTypeNav } from "./wegets/weget-view-type-nav/weget-view-type-nav";
import WegetCollectedSidebar from "./wegets/weget-collected-sidebar/weget-collected-sidebar";
import WegetCollectedLayout from "./wegets/weget-collected-layout/weget-collected-layout";
import { WegetCollectedSummary } from "./wegets/weget-collected-summary/weget-collected-summary";
import { WegetCollectedTable } from "./wegets/weget-collected-table/weget-collected-table";
import { WegetCollectedTopButtons } from "./wegets/weget-collected-top-buttons/weget-collected-top-buttons";

const Container = styled.div`
    background-color: var(--backgroundField);
    min-height:100vh;
    padding-bottom: 200px;
`;

export function MainView(props) {
    const queryParamsHook = useQueryParamsHook();

    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const commerceApiStoreInfoActionsContextHook = useCommerceApiStoreInfoActionsContextHook();

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        handleFetchCommerceApiStoreInfos();
    }, [apiInfoContextValueHook?.apiInfo?.apiKey, apiInfoContextValueHook?.apiInfo?.secretKey]);

    const handleFetchCommerceApiStoreInfos = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const fetchResult = await CommerceApiApi().searchCommerceApiStoreInfos({
            params: null,
            headers: headers
        })

        if (fetchResult?.content) {
            commerceApiStoreInfoActionsContextHook.commerceApiStoreInfos.setValue(fetchResult?.content);
        }
    }

    return (
        <>
            {(!queryParamsHook?.params?.ViewType || queryParamsHook?.params?.ViewType === 'MAIN') && (
                <Container>
                    <WegetCommerceApiStoreList />
                    <WegetCollectionButton />
                </Container>
            )}

            {(queryParamsHook?.params?.ViewType === 'COLLECTED') && (
                <Container>
                    <WegetViewTypeNav title={'주문수집'} />
                    <WegetCollectedLayout
                        sidebarItems={[{ name: 'test', count: 1 }]}
                    >
                        <WegetCollectedSummary />
                        <WegetCollectedTopButtons />
                        <WegetCollectedTable />
                    </WegetCollectedLayout>
                </Container>
            )}
        </>
    );
}